import { useState } from 'react'
import { MailWarning, X, Loader2 } from 'lucide-react'
import { useAuthStore } from '@/stores/auth.store'
import { apiClient } from '@/services/api.client'

export function EmailDogrulamaBanner() {
  const { kullanici } = useAuthStore()
  const [gizli, setGizli] = useState(() => sessionStorage.getItem('emailBannerGizli') === '1')
  const [gonderiyor, setGonderiyor] = useState(false)
  const [gonderildi, setGonderildi] = useState(false)

  if (!kullanici || kullanici.emailVerified !== false || gizli) return null

  const gizle = () => {
    sessionStorage.setItem('emailBannerGizli', '1')
    setGizli(true)
  }

  const tekrarGonder = async () => {
    setGonderiyor(true)
    try {
      await apiClient.post('/auth/send-verification')
      setGonderildi(true)
    } finally {
      setGonderiyor(false)
    }
  }

  return (
    <div className="bg-warning/10 border-b border-warning/30 px-4 py-2.5 flex items-center gap-3">
      <MailWarning className="w-4 h-4 text-warning shrink-0" />
      <p className="text-sm text-warning flex-1">
        E-posta adresiniz henüz doğrulanmadı.{' '}
        {gonderildi ? (
          <span className="font-medium">Doğrulama emaili gönderildi, lütfen gelen kutunuzu kontrol edin.</span>
        ) : (
          <button
            onClick={tekrarGonder}
            disabled={gonderiyor}
            className="underline hover:no-underline font-medium inline-flex items-center gap-1"
          >
            {gonderiyor && <Loader2 className="w-3 h-3 animate-spin" />}
            Doğrulama emaili gönder
          </button>
        )}
      </p>
      <button onClick={gizle} className="text-warning/60 hover:text-warning">
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
